import { Button, FileInput, Group, Modal, Text } from '@mantine/core';
import { IconDownload, IconFileTypeXls, IconUpload } from '@tabler/icons-react';
import { deviceApis } from '../../../../../shared/apis/device/apis';
import Swal from 'sweetalert2';
import { useState } from 'react';
import { queryClient } from '../../../../../shared/queryClient';
import { useLocation } from 'react-router-dom';
import { showSuccessNotification } from '../../../../ui/notification';
import { useExcelMutation } from './hooks/useExcelMutation';

interface IPropsExcelRegisterModal {
  opened: boolean;
  close: () => void;
}

export default function ExcelRegisterModal(props: IPropsExcelRegisterModal) {
  const { opened, close } = props;
  const location = useLocation();
  const path = location.pathname.split('/').pop();
  const [file, setFile] = useState<File | null>(null);
  const { uploadExcel } = useExcelMutation();

  const downloadExcelTemplate = async () => {
    try {
      const res = await deviceApis.shipment.getDispatchTemplate();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '출고등록 템플릿.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: '템플릿 다운로드 실패',
        text: '템플릿 다운로드에 실패했습니다.',
        confirmButtonText: '확인',
      });
    }
  };

  const buildFormData = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('channel', path === 'eptp' ? 'MFM' : path === 'manufacturer' ? 'SCAUTR' : 'PROGIX');
    return formData;
  };

  const onSubmitFile = () => {
    if (!file) {
      Swal.fire({
        icon: 'warning',
        title: '파일 선택 필요',
        text: '엑셀 파일을 업로드해주세요.',
        confirmButtonText: '확인',
      });
      return;
    }

    const formData = buildFormData(file);
    uploadExcel(formData, {
      onSuccess: () => {
        showSuccessNotification('등록 되었습니다.');
        queryClient.invalidateQueries(['getDispatchList']);
        setFile(null);
        close();
      },
    });
  };

  return (
    <Modal opened={opened} onClose={close} title="모드링크 출고등록" centered>
      <div>
        <Text size="sm">※ 출고 거래처 (From)과 입고 거래처 (To)의 회사코드를 입력해주세요.</Text>
        <Text size="sm">※ 기존에 등록된 MAC이 포함된 경우 등록되지 않습니다.</Text>
        <FileInput
          label="엑셀 파일 업로드"
          placeholder="파일을 선택하세요."
          accept=".xlsx, .xls"
          mt="md"
          leftSection={<IconFileTypeXls size={16} />}
          value={file}
          onChange={setFile}
          clearable
        />
      </div>
      <Group justify="center" mt="md">
        <Button color="secondary.5" leftSection={<IconUpload size={16} />} onClick={onSubmitFile}>
          파일 업로드
        </Button>
        <Button variant="outline" leftSection={<IconDownload size={16} />} onClick={downloadExcelTemplate}>
          탬플릿 내려받기
        </Button>
      </Group>
    </Modal>
  );
}
